import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoreChatlist } from '../../../Types/StoreTypes';
import { ChatList } from '../../../Types';

const initialState: StoreChatlist = {
    chatlist: [] as ChatList[],
    chatlistOpen: !localStorage.getItem('chatlistOpen') || localStorage.getItem('chatlistOpen') === 'true',
    chatlistOpenHover: false,
};

const chatlistSlice = createSlice({
    name: 'chatlist',
    initialState,
    reducers: {
        setChatlist: (state, action: PayloadAction<StoreChatlist['chatlist']>) => {
            state.chatlist = action.payload;
        },
        setChatlistOpen: (state, action: PayloadAction<StoreChatlist['chatlistOpen']>) => {
            state.chatlistOpen = action.payload;
        },
        setChatlistOpenHover: (state, action: PayloadAction<StoreChatlist['chatlistOpenHover']>) => {
            state.chatlistOpenHover = action.payload;
        },
    },
});

export const { setChatlist, setChatlistOpen, setChatlistOpenHover } = chatlistSlice.actions;

export default chatlistSlice.reducer;
